import { Component, Directive, ElementRef, OnInit, ViewChild, Input } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { Router } from "@angular/router";
import * as _ from 'lodash';
import { MatPaginator, MatSort } from '@angular/material';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { FuseUtils } from '../../../../../../../core/fuseUtils';
import { fuseAnimations } from '../../../../../../../core/animations';

/** Service file */
import { EcommerceOrdersService } from '../../orders.service';


@Component({
    selector: 'user-orders',
    templateUrl: './user-order-list.component.html',
    styleUrls: ['./user-order-list.component.scss'],
    animations: fuseAnimations,
})

export class UsersOrdersComponent implements OnInit {

    dataSource: FilesDataSource | null;

    attachmentLink: string;
    userRole: string;
    attachmentList: any = [];

    orderCount: number;
    id: number;

    @Input() hide: boolean;
    isLoading: boolean = false;
  
    //For Ic
    ownColumns = [
        'customer',
        'address',
        'product',
        'solForm'
    ];
    propertyTypes = {
        'HIQFULL': 'Full Spekwo',
        'GCCONSULTING': 'Walk and Talk',
        'INSPECTIONCALL': 'SpeK - Call',
        'RJCZPSJ': 'The Pre-List speK-Sheet',
        'CGPYWCK': 'Specific Item speKwo',
    };

    @ViewChild(MatPaginator) proOrdersPaginator: MatPaginator;
    @ViewChild('filter') filter: ElementRef;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private ordersService: EcommerceOrdersService,
        private router: Router,
    ) {
        this.userRole = window.localStorage.getItem('role');

    }

    ngOnInit() {
        this.isLoading = true;

        try {
            /**Other role -list own order */
            this.ordersService.getOwnOrders()
                .then(() => {
                    this.loadResult();
                })
                .catch(err => {
                    console.log('getOwnOrderserr', err);
                    this.isLoading = false;
                })
        }
        catch (err) {
            this.isLoading = false;
        }

    }
    loadResult() {
        this.isLoading = false;
        this.dataSource = new FilesDataSource(this.ordersService, this.proOrdersPaginator, this.sort);
        Observable.fromEvent(this.filter.nativeElement, 'keyup')
            .debounceTime(150)
            .distinctUntilChanged()
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }
                this.dataSource.filter = this.filter.nativeElement.value;
            });
        this.fetchReport();
        this.orderCount = this.ordersService.orders.length;
    }
    //fetching product types based on selection
    fetchingProduct(name) {
        return this.propertyTypes[name];
    }
    //view submit report
    viewReport(orderId) {
        var attachId = orderId - 1;
        for (const list of this.attachmentList) {
            if (list.id === attachId) {
                this.attachmentLink = list.downloadLink
            }
        }
        window.open(this.attachmentLink, '_blank');
    }
    //to open report solution form 
    viewForm(orderId) {
        // console.log('orderId', orderId);
        this.router.navigate(['/apps/e-commerce/solutionForm/' + orderId]);
    }

    fetchReport() {
        for (const order of this.ordersService.orders) {

            this.id = order.id - 1;
            this.ordersService.getAttachmentdata(this.id)
                .then((response) => {

                    if (response !== 'No records found') {
                        var currentOrderAttachLink = response.download_link.replace(/['"]+/g, '');
                        var isOrderHasAttachment = currentOrderAttachLink.includes("pdf");
                        var data = {
                            id: order.id - 1,
                            orderId: order.id,
                            title: response.post_title,
                            downloadLink: response.download_link,
                            hasFile: isOrderHasAttachment
                        }
                        this.attachmentList.push(data);
                    }

                })

        }

    }
    //Get current order attachment link
    checkOrderHasAttachment(currentOrderId) {
        var data = _.find(this.attachmentList, { orderId: currentOrderId });
        // console.log('dd', data);
        if (data !== undefined) {
            return data.hasFile;
        }
    }
}

export class FilesDataSource extends DataSource<any>
{
    _filterChange = new BehaviorSubject('');
    _filteredDataChange = new BehaviorSubject('');

    get filteredData(): any {
        return this._filteredDataChange.value;
    }

    set filteredData(value: any) {
        this._filteredDataChange.next(value);
    }

    get filter(): string {
        return this._filterChange.value;
    }

    set filter(filter: string) {
        this._filterChange.next(filter);
    }

    constructor(
        private ordersService: EcommerceOrdersService,
        private _paginator: MatPaginator,
        private _sort: MatSort
    ) {
        super();
        this.filteredData = this.ordersService.orders;
    }

    /** Connect function called by the table to retrieve one stream containing the data to render. */
    connect(): Observable<any[]> {
        const displayDataChanges = [
            this.ordersService.onOrdersChanged,
            this._paginator.page,
            this._filterChange,
            this._sort.sortChange
        ];
        return Observable.merge(...displayDataChanges).map(() => {
            let data = this.ordersService.orders.slice();

            data = this.filterData(data);

            this.filteredData = [...data];

            // Grab the page's slice of data.
            const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
            return data.splice(startIndex, this._paginator.pageSize);
        });

    }

    filterData(data) {
        if (!this.filter) {
            return data;
        }
        return FuseUtils.filterArrayByString(data, this.filter);
    }

    disconnect() {
    }
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/users/user-order-list/user-order-list.component.ts